import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import thumb1 from "assets/img/frontend/thumb1.jpg";

const AvailableRoom = () => {
  const [showMore, setShowMore] = useState(false);

  const baseFeatures = [
    "Very good breakfast included",
    "Book and pay now",
    "Free cancellation",
    "Free WiFi",
  ];

  const moreFeatures = [
    "Very good Lunch included",
    "Free WiFi",
    "Book and pay now",
    "Free cancellation",
  ];

  return (
    <div className="mx-auto mb-6 max-w-screen-2xl rounded-2xl bg-gray-50 p-4 shadow sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row">
        {/* Image */}
        <img
          src={thumb1}
          alt="Room"
          className="h-52 w-full rounded-lg object-cover sm:h-auto sm:w-1/3"
        />

        {/* Content */}
        <div className="flex flex-1 flex-col">
          {/* <div className="flex flex-col"> */}
          {/* Title & Price */}
          {/* <div className="mb-4 flex flex-wrap justify-between">
              <h2 className="text-lg font-bold text-blue-600">Normal room</h2>
              <div className="text-right">
                <p className="text-lg font-bold text-gray-800">₹999/night</p>
                <button className="mt-2 rounded-full bg-blue-600 px-4 py-1 text-white shadow">
                  Book now
                </button>
              </div>
            </div> */}

          {/* Base Features */}
          {/* <div className="flex flex-wrap gap-2">
              {baseFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="flex w-full items-center text-sm sm:w-1/2"
                >
                  <FaCheck className="mr-2 text-blue-600" />
                  <span>{feature}</span>
                </div>
              ))}
            </div> */}
          {/* </div> */}

          <div className="item-center flex justify-between">
            <div className="flex flex-wrap gap-2">
              {baseFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="flex w-full items-center text-sm sm:w-1/2"
                >
                  <FaCheck className="mr-2 text-blue-600" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            <div className="mt-4 flex flex-col items-end justify-between gap-2">
              <p className="text-lg font-bold text-gray-800">₹999/night</p>
              <button className="mt-2 rounded-full bg-blue-600 px-4 py-1 text-white shadow sm:mt-0">
                Book now
              </button>
            </div>
          </div>

          <hr className="my-4 border-gray-300" />

          {/* Collapsible More Features */}
          {showMore && (
            <div className="item-center flex justify-between">
              <div className="flex flex-wrap gap-2">
                {moreFeatures.map((feature, index) => (
                  <div
                    key={index}
                    className="flex w-full items-center text-sm sm:w-1/2"
                  >
                    <FaCheck className="mr-2 text-blue-600" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>

              <div className="mt-4 flex flex-col items-end justify-between gap-2">
                <p className="text-lg font-bold text-gray-800">₹1,499/night</p>
                <button className="mt-2 rounded-full bg-blue-600 px-4 py-1 text-white shadow sm:mt-0">
                  Book now
                </button>
              </div>
            </div>
          )}

          {/* Toggle Button */}
          <div className="mt-4 flex justify-center">
            <button
              onClick={() => setShowMore(!showMore)}
              className="flex items-center gap-2 rounded-full bg-blue-600 px-6 py-1.5 text-white transition"
            >
              {showMore ? "Show Less" : "Show More"}
              <span
                className={`transition-transform duration-300 ${
                  showMore ? "rotate-180" : ""
                }`}
              >
                ▼
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvailableRoom;
